// Bilder bestiller legger ved oppdraget (adkomst, lasteplass). Grensene speiles i storage.rules og firestore.rules.
export const MAX_ORDERER_PHOTOS = 5;
export const MAX_PHOTO_BYTES = 10 * 1024 * 1024;

// Legger gyldige bildefiler til listen. Returnerer ny liste og siste feilmelding (tom når alt gikk bra).
export function addPhotos(current, incoming) {
  const files = [...current];
  let error = '';
  for (const f of Array.from(incoming ?? [])) {
    if (!String(f.type).startsWith('image/')) { error = 'Bare bildefiler kan lastes opp.'; continue; }
    if (f.size >= MAX_PHOTO_BYTES) { error = 'Bildene kan være maks 10 MB hver.'; continue; }
    if (files.length >= MAX_ORDERER_PHOTOS) { error = `Du kan laste opp maks ${MAX_ORDERER_PHOTOS} bilder.`; break; }
    files.push(f);
  }
  return { files, error };
}
